<template>
<v-content class="spinelab-website-front">
  <v-container fluid fill-height>
    <v-flex xs12 sm8 md6 offset-md3>
      <v-card>
        <v-card-title primary-title>
          <v-spacer></v-spacer>
          <h1>ホームページ作成サービス管理者ログイン</h1>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-text-field
               label="ログインID"
               v-model="identifier"
               @keyup.enter="submit"
               required>
            </v-text-field>
            <v-text-field
               label="パスワード"
               v-model="password"
               :append-icon="invisible ? 'visibility' : 'visibility_off'"
               :append-icon-cb="() => (invisible = !invisible)"
               :type="invisible ? 'password' : 'text'"
               @keyup.enter="submit"
               required>
            </v-text-field>
          </v-form>
          <v-checkbox
            v-model="autoLogin"
            label="自動ログイン">
          </v-checkbox>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="submit"
                 color="primary"
                 :disabled="!identifier || !password"
                 :loading="loading">
            ログイン
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-container>
</v-content>
</template>

<script>
import { mapActions } from 'vuex';

const wrongPassword = 'ログインIDまたはパスワードが間違っています';

export default {
  name: 'AdminLogin',
  data() {
    return {
      identifier: '',
      password: '',
      loading: false,
      invisible: true,
    };
  },
  computed: {
    autoLogin: {
      get() {
        return this.$store.state.autoLogin;
      },
      set(value) {
        this.$store.commit('setAutoLogin', value);
      },
    },
  },
  methods: {
    ...mapActions(['adminLogin', 'showAlert']),
    async submit() {
      const { identifier, password } = this;
      if (!identifier || !password) {
        return;
      }
      this.loading = true;
      const logined = await this.adminLogin({ identifier, password });
      if (!logined) {
        this.loading = false;
        this.showAlert({ message: wrongPassword, type: 'error' });
        return;
      }
      this.$router.push({ name: 'AdminUsers' });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/admin/Login.vue